import { Component, AfterViewInit, OnDestroy, OnChanges, SimpleChanges, Input, ViewChild, ElementRef } from '@angular/core';
import { ChangeDetectionStrategy } from '@angular/core';
import { AppComponent } from '../../app.component';
import { TitleService } from '../../services/title.service';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-pagetoolbar',
  imports: [MatIconModule],
  templateUrl: './pagetoolbar.component.html',
  styleUrls: ['./pagetoolbar.component.scss'],
  providers: [], // Provide the service here
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PagetoolbarComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() label?: string;
  @Input() icon?: string;
  @ViewChild('bar', { static: true }) private bar!: ElementRef;
  private observer!: IntersectionObserver;

  constructor(
    private app: AppComponent,
    private title: TitleService
  ) {}

  ngAfterViewInit(): void {
    this.observer = this.app.observeIntersection((entries) => this.title.showSubtitle$.next(!entries[0].isIntersecting));
    this.observer.observe(this.bar.nativeElement);
  }

  ngOnInit(): void {
    this.title.subtitle$.next(this.label);
    this.title.showSubtitle$.next(false);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Update subtitle whenever the label input changes
    if (changes['label'] && !changes['label'].firstChange) {
      this.title.subtitle$.next(this.label);
    }
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
    this.title.showSubtitle$.next(false);
    this.title.subtitle$.next(undefined);
  }
}
